import {chainReducers, createDraftReducer, createFetchListReducer} from 'common/reducers/utils';

import Address from 'ondemand/types/Address';

const defaultReducer = chainReducers(
  createDraftReducer({
    name: 'rider address',
    DataType: Address,
    idProp: 'addressId',
  }),
  createFetchListReducer({
    name: 'rider address',
    pluralName: 'rider addresses',
  }),
);

export default function riderAddresses(state = {
  draft: {
    past: [],
    present: {
      model: null,
      errors: [],
    },
    future: [],
  },
  isFetching: false,
  items: null,
}, action) {
  return defaultReducer(state, action);
}



// WEBPACK FOOTER //
// ./src/ondemand/reducers/riderAddress.js